import { render, staticRenderFns } from "./shuiqin.vue?vue&type=template&id=dca8e2e2&scoped=true&"
import script from "./shuiqin.vue?vue&type=script&lang=js&"
export * from "./shuiqin.vue?vue&type=script&lang=js&"
import style0 from "./shuiqin.vue?vue&type=style&index=0&id=dca8e2e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca8e2e2",
  null
  
)

export default component.exports